export default __webpack_public_path__ + "static/media/teacher_schedule_mobile.1b67c51e.jpg";